import {
	IWebSdkTest,
	TWebSdkTestsResult
} from 'src/apps/dashboard/types/WebSdkDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { DashboardWebSdkRecentTestsQuery, DashboardWebSdkTestsQuery } from '../Tests.generated';

export const transformTestsResults = (
	rawResults: DashboardWebSdkTestsQuery | DashboardWebSdkRecentTestsQuery
): TWebSdkTestsResult => {
	let rows: IWebSdkTest[] = [];

	if ('wsdk_test_runs' in rawResults) {
		const results = rawResults as DashboardWebSdkTestsQuery;

		rows =
			results.wsdk_test_runs?.filter(returnNonNull).map((test) => ({
				runId: test.run_id,
				totalIssues: test.total_issues,
				criticalIssues: test.critical_issues,
				seriousIssues: test.serious_issues,
				runTime: test.run_time,
				testName: test.test_name,
				testPath: test.test_path
			})) ?? [];
	} else {
		const results = rawResults as DashboardWebSdkRecentTestsQuery;

		rows =
			results.wsdk_latest_test_runs?.filter(returnNonNull).map((test) => ({
				runId: test.run_id,
				totalIssues: test.total_issues,
				criticalIssues: test.critical_issues,
				seriousIssues: test.serious_issues,
				runTime: test.run_time,
				testName: test.test_name,
				testPath: test.test_path
			})) ?? [];
	}

	let total = 0;
	if (rawResults.total?.length) {
		total = rawResults.total[0]?.run_id_count ?? 0;
	}

	let unfilteredTotal = 0;
	if (rawResults.unfiltered_total?.length) {
		unfilteredTotal = rawResults.unfiltered_total[0]?.run_id_count ?? 0;
	}

	return {
		rows,
		total,
		unfilteredTotal
	};
};
